import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div>
    <div className='hero-container2'>
      <img src='/images/big.png'  />
      <video src='/videos/video.mp4' autoPlay loop muted />

      </div>
      
      </div>
  );
}

export default HeroSection;